import { ColumnOptionsBase, ServerSideColumnOption } from '../types/column-options';
import { AmountColumn, NumberColumn } from '../types/grid';
import { EntityColumnRef, GridRef, GroupColumnRef } from '../types/refs';

export interface CurrencyColumnOptions<TRow extends object> extends ColumnOptionsBase<TRow, number> {
  getCurrency:((row: TRow | undefined) => string | undefined);
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
}
export type ServerSideCurrencyColumnOptions<TRow extends object> = CurrencyColumnOptions<TRow> & ServerSideColumnOption;

export function amountColumn<TRow extends object>(ref: GridRef<TRow> | GroupColumnRef<TRow> | EntityColumnRef<TRow>,
                                                  options: CurrencyColumnOptions<TRow> | ServerSideCurrencyColumnOptions<TRow>): AmountColumn<TRow> {
  const column: AmountColumn<TRow> = {
    ...options,
    type: 'amount',
    format: options.format ?? 'CURRENCY.SYMBOL'
  }
  ref.createColumn(column);
  return column;
}
